function emphasizeWord(context, word) {
  const textToParse = $(context).html();
  const allHits = new RegExp(word, "ig");
  const rendered = textToParse.replace(allHits, `<strong class="a-search-hit">${word}</strong>`);
  $(context).html(rendered);
}

$(() => {
  $("[data-emphasize-word]").each((i, el) => {
    if ($(el).data("emphasize-word") != "") {
      emphasizeWord($(el), $(el).data("emphasize-word"));
    }
  });
});
